module.exports = __webpack_public_path__ + "static/media/bg.da8dd66b.svg";